import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';

import Display from '../../../util/Display';

class OzonetelItem extends React.Component {
  
  render() {
    return this.props.values.map((value, index) => 
      <div className="formhead col-md-12">
        <div className="row">
          <div className="col-md-3">
            <Select value={this.props.users.find(user => user.value === value.user)}
              onChange={user => this.props.onEdit(index, 'user', user.value)} 
              options={this.props.users} isSearchable={true} />
          </div>
          <div className="col-md-3">
            <FormControl type="text" placeholder="apiKey" value={value.apiKey} className="mr-sm-2"
              onChange={event => this.props.onEdit(index, 'apiKey', event.target.value) }/>
          </div>
          <div className="col-md-3">
            <FormControl type="text" placeholder="username" value={value.username} className="mr-sm-2"
              onChange={event=>this.props.onEdit(index, 'username', event.target.value)}/>
          </div>
          <div className="col-md-3">
            <FormControl type="text" placeholder="phone" value={value.phone} className="mr-sm-2"
              onChange={event=>this.props.onEdit(index, 'phone', event.target.value)}/> 
          </div>
          { Display.MultiAction(index, this.props.onAdd, this.props.onDelete) }
        </div>
      </div>
    );
  }
}
export default OzonetelItem;